(function ($) {

  const initializeBlock = function ($block) {
    function matchHeightFire() {
      $('.stats .stat .stat-title').matchHeight( {property: 'min-height'} );
    }
    matchHeightFire()

    $( window ).bind('resize orientationchange', function() {
      matchHeightFire();
    });

    setTimeout(function() {
      matchHeightFire();
    }, 1000)
  }

  $(document).ready(function () {
    $('.block--stats').each(function () {
      initializeBlock($(this));
    })
  })

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=stats', initializeBlock);
  }

})(jQuery);
